import { Utils } from '@everyboard/lib';
import { GameStateWithTable } from '../../jscaip/state/GameStateWithTable';
import { DiamPiece } from './DiamPiece';
export class DiamState extends GameStateWithTable {
    remainingPieces;
    static WIDTH = 8;
    static HEIGHT = 4;
    static ofRepresentation(representation, turn) {
        const board = representation.reverse();
        const pieces = [4, 4, 4, 4];
        for (let y = 0; y < DiamState.HEIGHT; y++) {
            for (let x = 0; x < DiamState.WIDTH; x++) {
                const piece = board[y][x];
                if (board[y][x] !== DiamPiece.EMPTY) {
                    pieces[DiamState.pieceIndex(piece)]--;
                }
            }
        }
        Utils.assert(pieces.every((remaining) => 0 <= remaining), 'Invalid DiamState representation uses too many pieces');
        return new DiamState(board, pieces, turn);
    }
    static pieceIndex(piece) {
        switch (piece) {
            case DiamPiece.ZERO_FIRST: return 0;
            case DiamPiece.ZERO_SECOND: return 1;
            case DiamPiece.ONE_FIRST: return 2;
            default:
                Utils.expectToBe(piece, DiamPiece.ONE_SECOND);
                return 3;
        }
    }
    constructor(board, remainingPieces, turn) {
        super(board, turn);
        this.remainingPieces = remainingPieces;
    }
    getRemainingPiecesOf(piece) {
        return this.remainingPieces[DiamState.pieceIndex(piece)];
    }
    getStackHeight(x) {
        let size = 0;
        for (let y = 0; y < DiamState.HEIGHT; y++) {
            if (this.getPieceAtXY(x, y) === DiamPiece.EMPTY) {
                break;
            }
            size++;
        }
        return size;
    }
}
